import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

class ProjectScopeSearchInput extends Component {

  static propTypes = {
    searchInputChange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    }
  }

  handleSearchInputChange = (e) => {
    this.setState({
      searchText: e.target.value
    });
    this.props.searchInputChange(e.target.value);
  };

  handleOnFocus = () => {
    document.body.classList.add('body--search');
    document.body.scrollTop = 0;
    setTimeout(() => {
      document.body.scrollTop = 0;
    }, 0);
  };

  handleOnBlur = () => {
    document.body.classList.remove('body--search');
  };

  render() {
    return (
      <div className="newscope-search">
        <FormattedMessage id="projectScope.searchPlaceholder" defaultMessage="search">
          {(placeholder) => (
            <input className={"ui-input newscope-search__input"
            + (this.state.searchText ? " newscope-search__input--no-icon" : "")} type="text"
                   value={this.state.searchText} onChange={this.handleSearchInputChange} placeholder={placeholder}
                   onFocus={this.handleOnFocus} onBlur={this.handleOnBlur}
            />
          )}
        </FormattedMessage>
        <span className="newscope-search__icon"/>
      </div>
    );
  }
}

const mapStateToProps = () => {
  return {

  };
};

export default connect(mapStateToProps, {

})(ProjectScopeSearchInput);
